// extracted by mini-css-extract-plugin
export default {"alert":"alert-VkdG","description":"description-S7VU"};